import styled from "styled-components";
import vimg from "../../images/icons/userIcon.png";
import leftChev from "../../images/leftArrow.png";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
const Container = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 2px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
`;
const ArrowContainer = styled.div`
  height: 16px;
  width: 7px;
  cursor: pointer;
`;
function Header({ children }) {
  const navigate = useNavigate();
  const { setCloseLogoutFormMobile } = useContext(AuthContext);
  const handleNavigateBack = () => {
    navigate("/pages");
  };
  return (
    <Container>
      <ArrowContainer onClick={handleNavigateBack}>
        <img src={leftChev} alt="" />
      </ArrowContainer>
      {children}
      <img src={vimg} alt="" style={{ cursor: "pointer" }} onClick={() => setCloseLogoutFormMobile(true)} />
    </Container>
  );
}

export default Header;
